import { FC, useMemo } from "react";
import cn from "classnames";
import { createAirEvents } from "features/shared/OpenedCardEvents/utils";
import { AirSearchCardModel } from "entities/AirSearchCard";
import { Nullable } from "shared/lib/typeCheck.lib";
import { t } from "shared/localization/localization";
import styles from "./EventList.module.scss";

import { Event } from "../Event";

type EventListProps = {
  className?: string;
  data: Nullable<AirSearchCardModel>;
};

export const EventList: FC<EventListProps> = ({ data, className }) => {
  const eventEntries = useMemo(() => createAirEvents(data?.getTransformedEvents(data?.events)), [data?.rawData]);

  const hasEventEntries = useMemo(() => {
    return !!(
      eventEntries.length &&
      eventEntries[0].subEvents.dateList.length &&
      eventEntries[0].subEvents.descriptionList.length
    );
  }, [eventEntries]);

  const errorMessage = data?.searchErrorText("Route is not available at the moment") ?? "";

  return (
    <div className={cn(styles.eventList, !hasEventEntries && styles.notAvailable, className)}>
      {hasEventEntries ? (
        eventEntries.map((eventEntry, eventEntryIndex) => {
          const isLastEvent = eventEntries.length - 1 === eventEntryIndex;

          return <Event key={eventEntryIndex} eventEntry={eventEntry} isLastEvent={isLastEvent} />;
        })
      ) : (
        <>
          <div className={styles.notAvailableBold}>{t(errorMessage)}.</div>
          <div className={styles.notAvailableNormal}>{t("Please, try again later")}.</div>
        </>
      )}
    </div>
  );
};
